export default {"src":"/_next/static/media/party-icon.1f53e412.svg","height":917,"width":990,"blurWidth":0,"blurHeight":0};